<template>
  <div class="bg-light">
    <b-form-group class="mx-auto my-3">
      <b-form-radio-group
        v-model="problems"
        name="butons1"
        class="customCheck1"
        button-variant="light"
        :options="options"
        stacked
        buttons
      >
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>
<script>
export default {
  props: {
    options: Array
  },
  data() {
    return {
      problems: []
    };
  }
};
</script>
